import { Blue, Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: 32,
  width: 256,
  minWidth: 256,
  height: 352,
  background: 'rgba(48, 54, 66, 0.8)',
  border: 'solid',
  borderColor: 'transparent',
  borderWidth: 4,
  borderRadius: '8px',
  color: Gray.Gray60,
  fontSize: '24px',
  fontWeight: 700
});

export const focused = css({
  border: 'solid',
  borderColor: Blue.Blue60,
  height: 352,
  borderWidth: 4,
  backgroundColor: Blue.Blue60
});

export const icon = css({
  width: '120px',
  height: '120px'
});

export const inverted = css({
  filter: 'invert(55%)'
});

export const text = css({
  marginTop: 45,
  color: Gray.Gray60
});

export const focusedText = css({
  marginTop: 45,
  color: White.White10
});
